module.exports = __webpack_public_path__ + "img/profiles_64x64.b52fb6cb.jpg";